module.exports = __webpack_public_path__ + "6cc5c81db55bd211e76cedb0d8eb8063.pdf";